import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import qs from 'qs';

import {marketInfoPropType} from 'utils/custom-proptypes';
import {SP_ACCOUNTS_URL, SPOTIFYCOM_URL, SUPPORT_SITE_URL, SP_EMBED_URL, SUSI_URL} from 'lib/shared/config/config';

import {withMarketInfo} from '../MarketInfo/MarketInfoProvider';

export const ConfigContext = React.createContext();

export const withConfig = Comp => props => (
  <ConfigContext.Consumer>{config => <Comp {...props} config={config} />}</ConfigContext.Consumer>
);

const getConfig = ({market, locale}) => {
  const conf = {
    supportSiteUrl: (path = '/') => `${SUPPORT_SITE_URL}/${market + path}`,
    spotifyComUrl: (path = '/') => `${SPOTIFYCOM_URL}/${market + path}`,
    spAccountsUrl: path => `${SP_ACCOUNTS_URL}/${locale.split('-')[0] + path}`,
    spEmbedUrl: path => `${SP_EMBED_URL}/${path}`,
  };

  conf.contactformAnonymous = () => conf.supportSiteUrl('/contact-spotify-anonymous/');

  return conf;
};

class ConfigProvider extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    marketInfo: marketInfoPropType,
    location: ReactRouterPropTypes.location.isRequired,
  };

  constructor(props) {
    super(props);
    // Used for flags such as mock_case_creation
    this.state = {
      customFlags: qs.parse(props.location.search, {ignoreQueryPrefix: true}).custom_flags,
    };
  }

  render() {
    const {marketInfo, children, location} = this.props;
    const {customFlags} = this.state;
    const plainRoutes = []; // TODO: currently no plain routes rendered by React
    const plainUI = plainRoutes.some(route => location.pathname === route || location.pathname.startsWith(`${route}/`));

    const caseCreateUrl = `${SUSI_URL}/case/create${customFlags ? `?custom_flags=${customFlags}` : ''}`;

    const contextValue = {
      ...getConfig(marketInfo),
      plainUI,
      caseCreateUrl,
    };

    return <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>;
  }
}

export default withMarketInfo(withRouter(ConfigProvider));
